import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AvailablePickupGroupExtensionsQueryVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
}>;


export type AvailablePickupGroupExtensionsQuery = { __typename?: 'Query', availablePickupGroupUsers?: Array<{ __typename?: 'PickupGroupUser', numberId: number, shortNumber: string, displayName: string } | null> | null };


export const AvailablePickupGroupExtensionsDocument = gql`
    query AvailablePickupGroupExtensions($groupId: Int!) {
  availablePickupGroupUsers(groupId: $groupId) {
    numberId
    shortNumber
    displayName
  }
}
    `;

/**
 * __useAvailablePickupGroupExtensionsQuery__
 *
 * To run a query within a React component, call `useAvailablePickupGroupExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePickupGroupExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePickupGroupExtensionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAvailablePickupGroupExtensionsQuery(baseOptions: Apollo.QueryHookOptions<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables> & ({ variables: AvailablePickupGroupExtensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>(AvailablePickupGroupExtensionsDocument, options);
      }
export function useAvailablePickupGroupExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>(AvailablePickupGroupExtensionsDocument, options);
        }
export function useAvailablePickupGroupExtensionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>(AvailablePickupGroupExtensionsDocument, options);
        }
export type AvailablePickupGroupExtensionsQueryHookResult = ReturnType<typeof useAvailablePickupGroupExtensionsQuery>;
export type AvailablePickupGroupExtensionsLazyQueryHookResult = ReturnType<typeof useAvailablePickupGroupExtensionsLazyQuery>;
export type AvailablePickupGroupExtensionsSuspenseQueryHookResult = ReturnType<typeof useAvailablePickupGroupExtensionsSuspenseQuery>;
export type AvailablePickupGroupExtensionsQueryResult = Apollo.QueryResult<AvailablePickupGroupExtensionsQuery, AvailablePickupGroupExtensionsQueryVariables>;